import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiGlobe } = FiIcons;

const Header = ({ title, showLanguageToggle = true }) => {
  const { language, switchLanguage, t, isRTL } = useLanguage();

  return (
    <header className="bg-gradient-to-r from-minecraft-green to-minecraft-blue text-white shadow-lg">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4 rtl:space-x-reverse">
            <div>
              <h1 className="text-xl font-bold">Minecraft Education Jordan Project</h1>
              <p className="text-sm opacity-90">{title || t('title')}</p>
            </div>
          </div>
          
          {showLanguageToggle && (
            <div className="flex items-center space-x-2 rtl:space-x-reverse">
              <SafeIcon icon={FiGlobe} className="w-5 h-5" />
              <select
                value={language}
                onChange={(e) => switchLanguage(e.target.value)}
                className="bg-white text-gray-800 rounded px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-minecraft-green"
              >
                <option value="en">English</option>
                <option value="ar">العربية</option>
              </select>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;